var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2838_996)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3333C0 16.0406 0.280952 16.7189 0.781049 17.219C1.28115 17.719 1.95942 18 2.66667 18H21.3333C22.0406 18 22.7189 17.719 23.219 17.219C23.719 16.7189 24 16.0406 24 15.3333V12H0V15.3333Z",
    fill: "#D62612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.9231C26 16.7391 25.6722 17.5218 25.0888 18.0988C24.5053 18.6758 23.714 19 22.8889 19H1.11111C0.285993 19 -0.50533 18.6758 -1.08878 18.0988C-1.67222 17.5218 -2 16.7391 -2 15.9231V2.07692C-2 1.26087 -1.67222 0.478245 -1.08878 -0.0987902C-0.50533 -0.675825 0.285993 -1 1.11111 -1H22.8889C23.714 -1 24.5053 -0.675825 25.0888 -0.0987902C25.6722 0.478245 26 1.26087 26 2.07692V15.9231Z",
    fill: "#E30917"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2838_996)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.3333C0 15.0406 0.280952 15.7189 0.781049 16.219C1.28115 16.719 1.95942 17 2.66667 17H21.3333C22.0406 17 22.7189 16.719 23.219 16.219C23.719 15.7189 24 15.0406 24 14.3333V11H0V14.3333Z",
    fill: "#D62612"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 -1H2.66667C1.95942 -1 1.28115 -0.719049 0.781049 -0.218952C0.280952 0.281145 0 0.959423 0 1.66667L0 5H24V1.66667C24 0.959423 23.719 0.281145 23.219 -0.218952C22.7189 -0.719049 22.0406 -1 21.3333 -1Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5H24V11H0V5Z",
    fill: "#00966E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 -1H1C0.20435 -1 -0.558711 -0.692034 -1.12132 -0.143851C-1.68393 0.404333 -2 1.14783 -2 1.92308L-2 15.0769C-2 15.8522 -1.68393 16.5957 -1.12132 17.1439C-0.558711 17.692 0.20435 18 1 18H22C22.7956 18 23.5587 17.692 24.1213 17.1439C24.6839 16.5957 25 15.8522 25 15.0769V1.92308C25 1.14783 24.6839 0.404333 24.1213 -0.143851C23.5587 -0.692034 22.7956 -1 22 -1Z",
    fill: "#EEEEEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 -1H9V6.07692L-3 6.07697V10.9231L9 10.9231V18H14V10.9231L25 10.9231V6.07697L14 6.07692V-1Z",
    fill: "#CE1124"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2 -1V20H26V-1H-2Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2838_996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 28,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2 -1V20H26V-1H-2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2838_996)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.11816 18.4993L1.04359 21.106L26.1386 1.83322L29.3892 -2.03953L22.8005 -2.91016L12.5647 5.39447L4.32571 10.991L-5.11816 18.4993Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.27539 20.3255L-1.13502 21.8375L28.2221 -2.39917H23.8147L-4.27539 20.3255Z",
    fill: "#F50100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1177 18.4993L22.956 21.106L-2.13902 1.83322L-5.38965 -2.03953L1.1991 -2.91016L11.4349 5.39447L19.6739 10.991L29.1177 18.4993Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9075 19.8101L25.768 21.3221L13.2677 10.9446L9.56125 9.78613L-5.70312 -2.02637H-1.29488L13.9599 9.50613L18.012 10.8956L28.9075 19.8101Z",
    fill: "#F50100"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3057 -2.75H8.69416V6H-3.72559V13H8.69416V21.75H15.3057V13H27.7744V6H15.3057V-2.75Z",
    fill: "#F50100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2838_996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 25
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3057 -2.75H8.69416V6H-3.72559V13H8.69416V21.75H15.3057V13H27.7744V6H15.3057V-2.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2838_996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69416 -2.75V-4.5H6.94416V-2.75H8.69416ZM15.3057 -2.75H17.0557V-4.5H15.3057V-2.75ZM8.69416 6V7.75H10.4442V6H8.69416ZM-3.72559 6V4.25H-5.47559V6H-3.72559ZM-3.72559 13H-5.47559V14.75H-3.72559V13ZM8.69416 13H10.4442V11.25H8.69416V13ZM8.69416 21.75H6.94416V23.5H8.69416V21.75ZM15.3057 21.75V23.5H17.0557V21.75H15.3057ZM15.3057 13V11.25H13.5557V13H15.3057ZM27.7744 13V14.75H29.5244V13H27.7744ZM27.7744 6H29.5244V4.25H27.7744V6ZM15.3057 6H13.5557V7.75H15.3057V6ZM8.69416 -1H15.3057V-4.5H8.69416V-1ZM10.4442 6V-2.75H6.94416V6H10.4442ZM-3.72559 7.75H8.69416V4.25H-3.72559V7.75ZM-1.97559 13V6H-5.47559V13H-1.97559ZM8.69416 11.25H-3.72559V14.75H8.69416V11.25ZM10.4442 21.75V13H6.94416V21.75H10.4442ZM15.3057 20H8.69416V23.5H15.3057V20ZM13.5557 13V21.75H17.0557V13H13.5557ZM27.7744 11.25H15.3057V14.75H27.7744V11.25ZM26.0244 6V13H29.5244V6H26.0244ZM15.3057 7.75H27.7744V4.25H15.3057V7.75ZM13.5557 -2.75V6H17.0557V-2.75H13.5557Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2838_996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2838_996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 21,
    fill: "white",
    transform: "translate(-2 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.31134f3e41324652c57894289b251420.svg";
export { ForwardRef as ReactComponent };